export default __webpack_public_path__ + "static/media/light-bulb.d9559466.png";